import script from "./JaStreamGroupDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupDetail.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupDetail.vue?vue&type=style&index=0&id=05825804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05825804"]])

export default __exports__